export interface DataTramLogo {
  dataUrl: string;
  /** Natural pixel width/height, used to keep the logo's aspect ratio when drawn at a fixed mm height. */
  widthPx: number;
  heightPx: number;
}

let cachedLogo: Promise<DataTramLogo | null> | null = null;

export function loadDataTramLogo(): Promise<DataTramLogo | null> {
  if (!cachedLogo) {
    cachedLogo = new Promise<DataTramLogo | null>(resolve => {
      const image = new Image();
      image.crossOrigin = "anonymous";
      image.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = image.naturalWidth;
        canvas.height = image.naturalHeight;
        const ctx = canvas.getContext("2d");
        if (!ctx) {
          resolve(null);
          return;
        }
        ctx.drawImage(image, 0, 0);
        resolve({
          dataUrl: canvas.toDataURL("image/png"),
          widthPx: image.naturalWidth,
          heightPx: image.naturalHeight,
        });
      };
      image.onerror = () => resolve(null);
      image.src = "/images/DpLogo.png";
    });
  }
  return cachedLogo;
}
